import routerOptions0 from "/home/runner/work/revolugo/revolugo/node_modules/.pnpm/nuxt@3.15.4_@types+node@22.15.31_eslint@9.28.0_rollup@4.43.0_sass-embedded@1.89.2_sass@_39f97648b5b46f810a822b3cc8f9662b/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}